export default __webpack_public_path__ + "static/media/flashtype.661ed4d6.png";